// extracted by mini-css-extract-plugin
export default {"chatbot-container":"_1GE1O","chatbotContainer":"_1GE1O","move-in-right":"_1npfi","moveInRight":"_1npfi","move-in-left":"_3Qy10","moveInLeft":"_3Qy10"};